import React, { FC } from 'react'
import { RegistrationForm } from '../RegistrationForm/RegistrationForm'
import { FormEmailField } from '../../../../formComponents/FormEmailField/FormEmailField'
import { FormFirstNameField } from '../../../../formComponents/FormFirstNameField/FormFirstNameField'
import { FormEducationalInstitutionField } from '../../../../formComponents/FormEducationalInstitutionField/FormEducationalInstitutionField'
import IFormRegistrationValues from '../../../IFormRegistrationValues'
import { FormFieldTypes } from '../../../../../emun/RegistrationFormFieldTypes'
import { IOrganizationsItem } from '../../../../../interfaces/IOrganizationsItem'
import { SocialNetworks } from '../../../../../emun/social'
import { FormLastNameField } from '../../../../formComponents/FormLastNameField/FormLastNameField'
import { FormPasswordField } from '../../../../formComponents/FormPasswordField/FormPasswordField'
import { FormPhoneField } from '../../../../formComponents/FormPhoneField/FormPhoneField'
import { IUserChangeParams } from '../../../../../interfaces/IUserChangeParams'

interface IForm14Values extends IFormRegistrationValues {
  [FormFieldTypes.PostStudent]: IOrganizationsItem
}

const initialForm14Data = {
  [FormFieldTypes.Email]: '',
  [FormFieldTypes.FirstName]: '',
  [FormFieldTypes.LastName]: '',
  [FormFieldTypes.Password]: '',
  [FormFieldTypes.Phone]: '',
  [FormFieldTypes.PostStudent]: { name: '' },
}

type RegistrationForm0Props = {
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string): void
}

export const onSubmit = (values: IForm14Values): IUserChangeParams => ({
  [FormFieldTypes.Password]: values[FormFieldTypes.Password],
  [FormFieldTypes.Phone]: values[FormFieldTypes.Phone].replace(/\s/g, '').replace('+', ''),
  [FormFieldTypes.FirstName]: values[FormFieldTypes.FirstName].trim(),
  [FormFieldTypes.LastName]: values[FormFieldTypes.LastName].trim(),
  [FormFieldTypes.Email]: values[FormFieldTypes.Email].trim(),
  [FormFieldTypes.Position]: values[FormFieldTypes.PostStudent].name.trim(),
})

export const RegistrationForm14: FC<RegistrationForm0Props> = ({ onSocialAuth }) => (
  <RegistrationForm onSocialAuth={onSocialAuth} initialFormData={initialForm14Data} onSubmit={onSubmit}>
    <FormFirstNameField />
    <FormLastNameField />
    <FormEmailField />
    <FormPasswordField />
    <FormPhoneField />
    <FormEducationalInstitutionField />
  </RegistrationForm>
)

RegistrationForm14.displayName = 'RegistrationForm14'
